export default __webpack_public_path__ + "media/images/logo-3ec2e29b7f558d23bfea09cd29d08de3.png";